import { dataBulbDashSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBulbDashSolid = /*#__PURE__*/createIcon(dataBulbDashSolid)
export default IconBulbDashSolid
